module.exports = __webpack_public_path__ + "img/financer.6241a2d9.png";